module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/technical.component.css
// module id = ./src/app/technical/technical.component.css
// module chunks = main